import { FunctionComponent } from "react";
import Badge from "../../badge/BadgeDefault";

export type BadgeNotificationType = {
  className?: string;
  label?: string;
  showLabel?: boolean;

  /** Variant props */
  size?: "sm" | "md" | "lg";
};

export const BadgeNotification: FunctionComponent<BadgeNotificationType> = ({
  className = "",
  size = "sm",
  label = "1",
  showLabel = true,
}) => {
  return (
    <Badge
      className={className}
      size={size}
      label={label}
      showLabel={showLabel}
      style="notification"
    />
  );
};

BadgeNotification.displayName = "BadgeNotification";
export default BadgeNotification;
